import { connect } from "react-redux";
import TrainingModuleDashboard from "./components/TrainingModuleResultTable";
import { useParams } from "react-router-dom";


const TrainingModuleResults = () => {
	
const { classeId } = useParams();

	return (
		
	    <div>
			<TrainingModuleDashboard classeId={classeId} />
	    </div>
    );
};

const mapStateToProps = (state) => ({
  	  
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModuleResults);